import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmProducts = styled.section`
  background-color: ${({ theme }) => theme.whiteSmoke};
  padding: 100px 0;
  font-family: ${({ theme }) => theme.fontText};

  .farm-products-title {
    margin: 0 0 30px;
    font-size: 42px;
    font-weight: 400;
    line-height: 1.15;
    color: ${({ theme }) => theme.black};

    strong {
      font-size: inherit;
      font-weight: 700;
    }
  }

  .farm-products-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }

  .pagination {
    padding-top: 50px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .farm-products-title {
      margin: 0 0 1.875rem;
    }

    .farm-products-grid {
      gap: 1.25rem;
    }

    .pagination {
      padding-top: 3.125rem;
    }

    padding: 3.5rem 0;

    .farm-products-title {
      font-size: 2rem;
    }

    .farm-products-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    padding: 1.75rem 0;

    .farm-products-title {
      font-size: 1.75rem;
      margin-bottom: 1.25rem;
    }

    .farm-products-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .pagination {
      padding-top: 1.5rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .container {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .farm-products-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }
  }
`;
